import { useEffect, useState } from "react";
import Form from "../../../Reusable/Form/Form.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import useMediaQueries from "hooks/useMediaQueries.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useUploader } from "../../../../contexts/uploaderContext/uploaderContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { MultipleShareInput } from "components/Reusable/SideBar/Share/MultipleShareInput.js";
import { setLocalStorage, getLocalStorage } from "utils/globalLocalStorage.js";
import { generateLinkFields, sendFields } from "./formsFields.js";

export const SendToFormComponent = ({
  body,
  getFormValuesRef,
  setBody,
  handleSubmit,
}) => {
  const { getRecipientEmail, setHideSubmit, getUploading, getHideSubmit } =
    useUploader();
  const { getTextByKey } = useContent();
  const { mobileCondition } = useMediaQueries();
  const { getUserData, isLoggedIn } = useUser();

  const [fields, setFields] = useState(sendFields);
  const [viaLink, setViaLink] = useState(
    getLocalStorage("sendViaLink") === "link"
  );

  // changing fields of the form when user changed type of submition
  useEffect(() => {
    setLocalStorage("sendViaLink", viaLink ? "link" : "email");
    if (viaLink) {
      const fields = { ...generateLinkFields };
      if (getUserData().HideJumboPay) delete fields.ChargeFiles;
      setFields(fields);
    } else {
      const fields = {
        ...sendFields,
        SendToEmail: {
          element: "customelement",
          fieldKey: "SendToEmail",
          label: "moveable",
          validation: {
            validate: (array) => array.length > 0,
          },
          render: (props) => (
            <MultipleShareInput
              {...props}
              defaultValue={
                body.SendToEmail ? body.SendToEmail : [getRecipientEmail()]
              }
              recipientsList={[]}
              autofocus={!mobileCondition}
            />
          ),
        },
      };
      if (getUserData().HideJumboPay) delete fields.ChargeFiles;
      setFields(fields);
    }
  }, [viaLink]);

  // logic to hide jumbopay option in case its hiden by user details
  useEffect(() => {
    if (getUserData().HideJumboPay) {
      setFields((prev) => {
        const newFields = { ...prev };
        delete newFields.ChargeFiles;
        return newFields;
      });
    }
  }, [getUserData().HideJumboPay]);

  // logic to show submit button in case user swapped to send via link or email
  useEffect(() => {
    if (getUploading() && getHideSubmit()) {
      setHideSubmit(false);
    }
  }, [viaLink]);

  // default values for the form
  const defaultValuesObj = {
    ...body,
    SendOwnerEmail: isLoggedIn() ? getUserData().UserName : body.SendOwnerEmail,
    SendToEmail: getRecipientEmail() ? [getRecipientEmail()] : [],
  };

  return (
    <div className="send-form-container">
      <div className="send-form-header">
        <button
          className={`send-form-via-option ${viaLink ? "" : "current"}`}
          onClick={() => {
            setViaLink(false);
          }}
        >
          <Icon name="send" />
          {getTextByKey("send-via-email")}
        </button>
        <button
          className={`send-form-via-option ${!viaLink ? "" : "current"}`}
          onClick={() => {
            setViaLink(true);
          }}
        >
          <Icon name="link-symbol" />
          {getTextByKey("send-via-link")}
        </button>
      </div>
      <Form
        fieldsProps={{ field: "none", label: "moveable " }}
        fields={fields}
        onSubmit={handleSubmit}
        defaultValuesObj={defaultValuesObj}
        submitProps={{
          title: getTextByKey(getUploading() ? "update-details" : "send-files"),
          onMouseDown: (e) => {
            e.preventDefault();
          },
          hidden: true,
        }}
        buttonProps={{ buttonsSize: "large" }}
        checkAndReturnValuesFunc={getFormValuesRef}
        externalProps={{
          body,
          setBody,
        }}
        // captchaProvider="cloudflare"
        // cloudflareActionName="updateMailDetails"
      />
      {/* {captchaRequired ? (
        <Recaptcha
          recaptchaRef={recaptchaRef}
          onSuccess={(token) => setCaptchaToken(token)}
          provider="cloudflare"
        />
      ) : null} */}
    </div>
  );
};
